<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">{{ account.account_name }} ユーザーの一覧</div>
        </div>
        <a class="c-btn c-btn--blue u-w250">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
          </div>
          <p class="c-btn__text" @click="onClickShowNewUser">新規ユーザーの作成</p>
        </a>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-result__data">
            <div class="c-error">
              <div class="c-error__txt">ユーザーが存在しません</div>
            </div>
            <table class="c-table">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w120 is-sortable">
                    <span class="c-table__text">名前</span>
                    <span class="c-btn c-btn--sort" data-type="user_name"></span>
                  </th>
                  <th class="c-table__cell--center u-w180 is-sortable">
                    <span class="c-table__text">メールアドレス（ログインID）</span>
                    <span class="c-btn c-btn--sort" data-type="email"></span>
                  </th>
                  <th class="c-table__cell--center u-w200">
                    <span class="c-table__text">ログインできるプロジェクト</span>
                    <span class="c-btn c-btn--sort" data-type="project"></span>
                  </th>
                  <th class="c-table__cell--center u-w60">
                    <span class="c-table__text">契約者</span>
                    <span class="c-btn c-btn--sort" data-type="contractor_flag"></span>
                  </th>
                  <th class="c-table__cell--center u-w80">
                    <span class="c-table__text">権限</span>
                    <span class="c-btn c-btn--sort" data-type="user_role"></span>
                  </th>
                </tr>
              </thead>

              <tbody class="is-editable">
                <tr v-for="(value, key) in users" :key="key">
                  <td class="c-table__cell--center c-table__cell--middle u-w120">{{ value.user_name }}</td>
                  <td class="c-table__cell--middle u-w180">{{ value.login_id }}</td>
                  <td class="c-table__cell--middle">
                    <span v-for="(accountUserService, loopIndex1) in value.account_user_services" :key="loopIndex1">
                      <span v-show="accountUserService.service.delete_flag == 0">{{ accountUserService.service.service_name }}<br /></span>
                    </span>
                  </td>
                  <td class="c-table__cell--middle u-w60">{{ getContractorLabel(value.contractor_flag) }}</td>
                  <td class="c-table__cell--center c-table__cell--middle u-wh100">
                    {{ getUserRoleLabel(value.user_role) }}
                    <div class="c-table-editable">
                      <ul class="c-table-editable-list">
                        <li v-show="!value.is_system_admin" class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickSelectAccountUser(value.user_name, value.login_id, value.user_id)">
                            <div class="c-btn__text c-btn__text--balloon">選択する</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#flag" />
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li v-show="!value.is_system_admin" class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickShowUserEdit(value.user_id)">
                            <div class="c-btn__text c-btn__text--balloon">編集する</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#edit" />
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li v-show="!value.is_system_admin" class="c-table-editable-list__item">
                          <a class="c-btn c-btn--white c-btn--circle" @click="onClickDeleteAccount(value.user_id, value.user_name)">
                            <div class="c-btn__text c-btn__text--balloon">削除する</div>
                            <div class="c-icon c-icon--gray-3 u-wh20">
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                              >
                                <use xlink:href="/assets/img/sprite.svg#trash" />
                              </svg>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: アカウント削除確認 -->
    <control-modal
      ref="refDeleteUserModal"
      classes="c-modal--common"
      title="以下のユーザーを削除しますか?"
      :body="`${deleteAccountUserName}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteUser
      :on-close-click="onCloseDeleteUserModal"
      :on-cancel-click="onCloseDeleteUserModal"
      :on-enter-click="onEnterDeleteUserModal"
    />

    <!-- モーダル: アカウント選択確認 -->
    <control-modal
      ref="refSelectUserModal"
      classes="c-modal--common"
      title="以下のユーザーでログインしますか?"
      :body="`${selectLoginId}`"
      cancel-button-label="キャンセル"
      enter-button-label="選択する"
      :is-active=isSelectUser
      :on-close-click="onCloseSelectUserModal"
      :on-cancel-click="onCloseSelectUserModal"
      :on-enter-click="onEnterSelectUserModal"
    />

  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    account: Object,
    breadcrumbData: Array,
    searchQuery: String,
    users: Array,
  },

  data() {
    return {
      deleteAccountUserId: '',
      deleteAccountUserName: '',
      selectUserName: '',
      selectUserId: '',
      selectLoginId: '',
      isDeleteUser: false,
      isSelectUser: false
    };
  },

  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    onClickShowNewUser: function() {
      location.href = '/coins-admin/account/' + this.account.account_id + '/users/new';
    },
    onClickShowUserEdit: function(accountUserId) {
      location.href = '/coins-admin/account/' + this.account.account_id + '/users/' + accountUserId;
    },

    onClickDeleteAccount: function(accountId, accountName) {
      this.isDeleteUser = true;
      this.deleteAccountUserName = accountName;
      this.deleteAccountUserId = accountId;
    },
    onClickSelectAccountUser: function(userName, loginId, userId) {
      this.isSelectUser = true;
      this.selectUserName = userName;
      this.selectUserId = userId;
      this.selectLoginId = loginId;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 操作モーダル（アカウント削除）を閉じる処理
    onCloseDeleteUserModal() {
      this.isDeleteUser = false
      this.errorMessage = ''
      this.$refs.refDeleteUserModal.resetErrorMessage();
    },

    onCloseSelectUserModal() {
      this.isSelectUser = false
      this.errorMessage = ''
      this.$refs.refSelectUserModal.resetErrorMessage();
    },

    // クリック: 操作モーダル（アカウント削除）を閉じる処理
    onEnterDeleteUserModal() {
      this.$refs.refDeleteUserModal.showLoader();
      axios
        .delete('/api/accounts/' + this.account.account_id + '/users/' + this.deleteAccountUserId)
        .then((_res) => {
          // TODO: UI
          this.$refs.refDeleteUserModal.hideLoader();
          location.reload();
        })
        .catch((_error) => {
          this.$refs.refDeleteUserModal.hideLoader();
          this.$refs.refDeleteUserModal.showErrorMessage('アカウントユーザーを削除出来ませんでした');

        });
    },

    onEnterSelectUserModal() {
      this.$refs.refSelectUserModal.showLoader();
      axios
        .post('/api/accounts/' + this.account.account_id + '/users/' + this.selectUserId + '/select')
        .then((_res) => {
          this.$refs.refSelectUserModal.hideLoader();
          location.href = '/coins-admin/';
        })
        .catch(error => {
          this.$refs.refSelectUserModal.hideLoader();
          this.$refs.refSelectUserModal.showErrorMessage(error.response.data.message);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // その他
    // -----------------------------------------------------------------------------------------------------
    getUserRoleLabel(userRole) {
      switch (parseInt(userRole)) {
      case 1:
        return 'システム管理者';
      case 2:
        return 'サイト管理者';
      case 3:
        return '一般';
      default:
        return '';
      }
    },
    getContractorLabel(contractorFlag) {
      if (contractorFlag == 1) {
        return '契約者';
      }
      return '一般';
    }
  }
};
</script>
